import React from 'react'
import StyledText from '../../../../components/StyledComponents/StyledText'
import { useTheme } from '../../../../middleware/ThemeContext'
import { font } from '../../../../utils/themes';
import { ProfileImage } from '../../../../components/listing/DataTable';
import PlaceholderImage from "../../../../assets/images/placeholder-image.jpg";

interface UserInfoProps { 
    image?: string;
    name: string;
    subTitle: string; 
}

const UserInfo: React.FC<UserInfoProps> = ({ image, name, subTitle }) => {
    const {theme} = useTheme();
  return (
    <div className='d-flex gap-2'>
        <ProfileImage $src={image || PlaceholderImage}>
            <img
                src={image || PlaceholderImage}
                alt={image}
                onError={(e) => {
                (e.target as HTMLImageElement).src = PlaceholderImage;
                }}
            />
        </ProfileImage>
        <div>
            <StyledText
                fontSize='13px'
                fontWeight={600}
                textColor={theme.CorporateTheme.colors.headerColor}
            >
                {name}
            </StyledText>
            <StyledText
                fontSize='12px'
                fontWeight={400}
                fontFamily={font.lato}
                textColor={theme.CorporateTheme.colors.textSecondary}
            >
                {subTitle}
            </StyledText>
        </div>
    </div>
  )
}

export default UserInfo